import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/da/localalarmanalysisregulation/getpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/da/localalarmanalysisregulation/getdetail/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getClientPage = (params, urlParams) => {
  return axios.request({
    url: '/da/localalarmanalysisregulation/getclientpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const datevehicleInfoGrouplocalalarmlimit = (params, urlParams) => {
  return axios.request({
    url: '/da/localalarmanalysisregulation/localalarmanalysisregulation/updatevehicleInfoGrouplocalalarmlimit/' + params.vehicleInfoGroupids + '/' + params.localalarmlimit + '/' + params.type + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const datelocalalarmlimit = (params, urlParams) => {
  return axios.request({
    url: '/da/localalarmanalysisregulation/localalarmanalysisregulation/' + params.terminalNum + '/' + params.localalarmlimit + '/' + params.type + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

